import axios from 'axios'
import React, { useState } from 'react'
import useSWR from '../../../hooks/useSWR'

import { swalError, swalSuccess } from '../../../common/components/Swaler'

const RentalCompanies = () => {
  const [rentalCompany, setRentalCompany] = useState(null)

  const { data: list, mutate } = useSWR('/subject/admin/rental_companies')

  const updateRentalCompany = async ({ _id, email }) => {
    if (!email || email.length < 5) return swalError('Mailadressen måste ha minst 5 tecken')

    mutate((prev) => prev.map((rc) => (rc._id === _id ? { ...rc, email } : rc)))

    axios
      .put(`/subject/admin/rental_companies/${_id}`, { email })
      .then(() => swalSuccess('Uppdaterat', '', 'OK'))
      .catch((e) => {
        swalError('Fel', e.message)
      })
  }

  return (
    <div>
      <br />
      <div className="flex" style={{ justifyContent: 'start' }}>
        {list?.map((d) => (
          <div key={d._id} style={{ background: '#fff', cursor: 'pointer', margin: 2, padding: 2 }} onClick={() => setRentalCompany(d)}>
            {d.name}
          </div>
        ))}
      </div>
      {rentalCompany && (
        <div>
          <p>{`Ändra ${rentalCompany.name || 'Okänd'}s uppgifter`}</p>
          <div>
            <span>
              <input type="text" value={rentalCompany.email || ''} onChange={(e) => setRentalCompany({ ...rentalCompany, email: e.target.value })} placeholder="Email" />
              <button onClick={() => updateRentalCompany(rentalCompany)}>Uppdatera</button>
            </span>
          </div>
        </div>
      )}
    </div>
  )
}

export default RentalCompanies
